import {ApiRes} from '../../types/api'
import {apiGet, API_URL} from '../api'

interface IReward {}

export const getUserReward = async (user_id?: string): Promise<ApiRes<any>> => {
    return await apiGet(API_URL, `admin/exchange/referral/reward?user_id=${user_id}`)
}
